// ActionBar — THE action row on Home. One component, one order, everywhere.
//
// Operator rule (2026-08-12): never cluttered, never inconsistent. The four
// doors and their order are lib/routes.ts's ACTION rows — the same four, in
// the same order, as the rail's pinned buttons and the phone's More sheet
// (sweep item 71, 14 Sept 2026: "the rail's and Home's four actions become
// one ordered list"). Expense, capital and drawing are modes inside Record
// money, reachable from its selector or the ⌘K palette; Adjust balance is
// the audit door and keeps its friction (palette, party page, Treasury).
// Nothing else earns a button here.
//
// Desktop: compact row (gold primary + ghost secondaries).
// Mobile: 2×2 grid, Book trade visually primary.

import { Link } from 'react-router-dom';
import { navRoutes } from '../lib/routes';

const ACTIONS = navRoutes('action');

export function ActionBar() {
  return (
    <section className="grid grid-cols-2 gap-2 lg:flex lg:flex-wrap lg:gap-2.5">
      {ACTIONS.map(({ path, title, icon: Icon, primary }) => (
        <Link
          key={path}
          to={path}
          className={
            primary
              ? 'btn-primary text-center text-body py-2 flex items-center justify-center gap-1.5 lg:w-auto lg:px-4'
              : 'btn-secondary text-center text-body py-2 flex items-center justify-center gap-1.5 lg:w-auto lg:px-4'
          }
        >
          {Icon && <Icon className="w-4 h-4" />}
          {title}
        </Link>
      ))}
    </section>
  );
}
